import { useState, useEffect } from 'react'
import { strapiService } from '../services/strapiService'
import { BibliotecaPage } from '../types/strapi'

export function useBiblioteca() {
  const [data, setData] = useState<BibliotecaPage | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const fetchData = async () => {
    try {
      setLoading(true)
      setError(null)
      const response = await strapiService.getBiblioteca()
      setData(response.data)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erro desconhecido')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  const refetch = () => {
    fetchData()
  }

  return { data, loading, error, refetch }
} 